import { programTypesConfigContext } from "../../contexts/programTypes/programTypesConfig.context";

const getNonSquareFtProgramsTypes = () =>
  programTypesConfigContext.config
    .filter((programType) => programType.hasNonSquareFootagePricing)
    .map((programType) => programType.name);

export default getNonSquareFtProgramsTypes;
